import React, { useState } from 'react';
import api from '../api';
import { Editor } from '@tinymce/tinymce-react';

const progressBarStyle = {
  width: '100%',
  height: '20px',
  backgroundColor: '#f0f0f0',
  borderRadius: '10px',
  overflow: 'hidden',
  marginTop: '10px'
};

const progressFillStyle = {
  height: '100%',
  backgroundColor: '#4CAF50',
  transition: 'width 0.3s ease'
};

const AdminUpload = () => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('ssc');
  const [testType, setTestType] = useState('simple');
  const [timeLimit, setTimeLimit] = useState('');
  const [dictationWpm, setDictationWpm] = useState('');
  const [audio, setAudio] = useState(null);
  const [expectedText, setExpectedText] = useState('');
  const [message, setMessage] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notificationData, setNotificationData] = useState({ title: '', content: '', type: 'free', date: '', link: '' });

  const handleNameChange = (e) => setName(e.target.value);
  const handleCategoryChange = (e) => setCategory(e.target.value);
  const handleTestTypeChange = (e) => setTestType(e.target.value);
  const handleTimeLimitChange = (e) => setTimeLimit(e.target.value);
  const handleDictationWpmChange = (e) => setDictationWpm(e.target.value);
  const handleFileChange = (e) => setAudio(e.target.files[0]);
  const handleExpectedTextChange = (content) => setExpectedText(content);

  const handleNotificationChange = (field, value) => {
    setNotificationData(prev => ({ ...prev, [field]: value }));
  };

  const handleCreateNotification = async (e) => {
    e.preventDefault();
    try {
      await api.post('/notifications', notificationData);
      alert('Notification created successfully!');
      setNotificationData({ title: '', content: '', type: 'free', date: '', link: '' });
      setShowNotificationModal(false);
    } catch (error) {
      alert('Failed to create notification.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !category || !timeLimit || !dictationWpm || !audio || !expectedText) {
      setMessage('All fields are required.');
      return;
    }
    const formData = new FormData();
    formData.append('name', name);
    formData.append('category', category);
    formData.append('testType', testType);
    formData.append('timeLimit', timeLimit);
    formData.append('dictationWpm', dictationWpm);
    formData.append('audio', audio);
    formData.append('expectedText', expectedText);
    try {
      setIsUploading(true);
      setUploadProgress(0);
      await api.post('/admin/tests', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(progress);
        }
      });
      setMessage('Test uploaded successfully.');
      setName('');
      setCategory('ssc');
      setTimeLimit('');
      setDictationWpm('');
      setAudio(null);
      setExpectedText('');
      setIsUploading(false);
    } catch (err) {
      setMessage('Upload failed.');
      console.error(err);
      setIsUploading(false);
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Upload New Test</h2>
      {message && <p>{message}</p>}
      {isUploading && (
        <div>
          <p>Uploading... {uploadProgress}%</p>
          <div style={progressBarStyle}>
            <div style={{...progressFillStyle, width: `${uploadProgress}%`}}></div>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Test Name:</label><br />
          <input
            type="text"
            value={name}
            onChange={handleNameChange}
            required
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Category:</label><br />
          <select
            value={category}
            onChange={handleCategoryChange}
            required
            style={{ width: '100%' }}
          >
            <option value="ssc">SSC</option>
            <option value="court">Court</option>
            <option value="others">Others</option>
          </select>
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Test Type:</label><br />
          <select
            value={testType}
            onChange={handleTestTypeChange}
            required
            style={{ width: '100%' }}
          >
            <option value="simple">Simple</option>
            <option value="premium">Premium</option>
            <option value="hidden">Hidden</option>
          </select>
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Time Limit (seconds):</label><br />
          <input
            type="number"
            value={timeLimit}
            onChange={handleTimeLimitChange}
            required
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Dictation WPM:</label><br />
          <input
            type="number"
            value={dictationWpm}
            onChange={handleDictationWpmChange}
            required
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Audio File:</label><br />
          <input
            type="file"
            accept="audio/*"
            onChange={handleFileChange}
            required
            style={{ width: '100%' }}
          />
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label>Expected Text:</label><br />
          <Editor
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            licenseKey="gpl"
            value={expectedText}
            onEditorChange={handleExpectedTextChange}
            init={{
              height: 200,
              menubar: false,
              plugins: 'lists link image code',
              toolbar: 'undo redo | fontfamily fontsize',
              font_family_formats: `
                Kruti Dev 010=Kruti Dev 010;
              `,
              content_style: `
                @font-face { font-family: 'Kruti Dev 010'; src: url('/fonts/KrutiDev_010.ttf') format('truetype'); }
                body { font-family: 'Kruti Dev 010', monospace; }
              `
            }}
          />
        </div>
        <button type="submit" style={{ padding: '0.5rem 1rem', background: '#2980b9', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          Upload (जमा करें)
        </button>
      </form>

      <button 
        onClick={() => setShowNotificationModal(true)}
        style={{ 
          marginTop: '1rem', 
          padding: '0.5rem 1rem', 
          background: '#27ae60', 
          color: '#fff', 
          border: 'none', 
          borderRadius: '4px', 
          cursor: 'pointer' 
        }}
      >
        Create Notification
      </button>

      {showNotificationModal && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundColor: 'rgba(0,0,0,0.5)', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          zIndex: 1000 
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '2rem', 
            borderRadius: '8px', 
            width: '400px' 
          }}>
            <h3>Create Notification</h3>
            <form onSubmit={handleCreateNotification}>
              <div style={{ marginBottom: '1rem' }}>
                <label>Title:</label>
                <input
                  type="text"
                  value={notificationData.title}
                  onChange={(e) => handleNotificationChange('title', e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Content:</label>
                <textarea
                  value={notificationData.content}
                  onChange={(e) => handleNotificationChange('content', e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem', height: '100px' }}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Type:</label>
                <select
                  value={notificationData.type}
                  onChange={(e) => handleNotificationChange('type', e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
                >
                  <option value="free">Free</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Date:</label>
                <input
                  type="date"
                  value={notificationData.date}
                  onChange={(e) => handleNotificationChange('date', e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
                />
              </div>
              <div style={{ marginBottom: '1rem' }}>
                <label>Link (optional):</label>
                <input
                  type="url"
                  value={notificationData.link}
                  onChange={(e) => handleNotificationChange('link', e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginTop: '0.25rem' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button type="submit" style={{ flex: 1, padding: '0.5rem', background: '#27ae60', color: 'white', border: 'none', borderRadius: '4px' }}>
                  Create
                </button>
                <button 
                  type="button" 
                  onClick={() => setShowNotificationModal(false)}
                  style={{ flex: 1, padding: '0.5rem', background: '#95a5a6', color: 'white', border: 'none', borderRadius: '4px' }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminUpload;
